/* eslint react/no-danger: 'off' */
/* global globals, translations */
import React from 'react';
import get from 'lodash/get';

const PaymentSuccessSubscriptionVip = () => {
  const thankYou = get(translations, 'txt: Paldies, ka iegādājies {:hostname} VIP abonementu!', '')
    // .replace('{:hostname}', `<a href="/">${window.location.hostname}</a>`);
    .replace('{:hostname}', `<a href="/">${get(globals, 'currentDomainName', 'otrapuse.lv')}</a>`);

  let activeUntil = null;
  const subscriptionVipEndtime = get(globals, 'subscriptionVipEndtime', null);
  if (subscriptionVipEndtime) {
    const date = new Date(subscriptionVipEndtime * 1000);
    const dateString = `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}.`;
    activeUntil = get(translations, 'txt: Tavs VIP abonements ir aktīvs līdz {:termins}!', '')
      .replace('{:termins}', dateString);
  }

  return (
    <div className="mtm">
      <div dangerouslySetInnerHTML={{ __html: thankYou }} />
      <div dangerouslySetInnerHTML={{ __html: activeUntil }} />
      <div className="mtm">
        <a href="/">{get(translations, 'txt: Sākums', '')}</a>
      </div>
    </div>
  );
};

export default PaymentSuccessSubscriptionVip;
